import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaselayersComponent } from './baselayers.component';


@NgModule({
  declarations: [BaselayersComponent],
  imports: [
    CommonModule
  ],
  exports: [BaselayersComponent]
})
export class BaselayersModule { }
